import { Component } from '@theme/component'
import { useGsap } from '@theme/gsap'
import { mediaQueryLarge } from '@theme/use-device-detection'
import { usePointerInertia } from '@theme/use-pointer-inertia'
import { useStickerReveal } from '@theme/use-sticker-reveal'

const stickerSelector = '[data-scroll-animation-target]'
const inertiaElementSelector = '[data-inertia-element]'
const noPreference = '(prefers-reduced-motion: no-preference)'

class FooterStickers extends Component {
  /** @type {{ revert: () => void } | null} */
  #gsapContext = null

  /** @type {(() => void) | null} */
  #teardownInertia = null

  /** @type {(() => void) | null} */
  #teardownStickerReveal = null

  mounted() {
    void this.#initAnimations()
  }

  unmounted() {
    this.#gsapContext?.revert()
    this.#gsapContext = null
    this.#teardownInertia?.()
    this.#teardownInertia = null
    this.#teardownStickerReveal?.()
    this.#teardownStickerReveal = null
  }

  async #initAnimations() {
    if (!(mediaQueryLarge.matches && matchMedia(noPreference).matches)) return

    const scope = await useGsap(this, undefined, ['InertiaPlugin'])

    if (!(scope && this.isConnected && globalThis.InertiaPlugin)) {
      scope?.context.revert()
      return
    }

    scope.contextSafe(() => {
      const mm = scope.gsap.matchMedia(this)
      mm.add(
        { desktop: mediaQueryLarge.media, motion: noPreference },
        (context) => {
          if (!(context.conditions.desktop && context.conditions.motion)) return
          this.#teardownStickerReveal = useStickerReveal(
            scope.gsap,
            this.querySelectorAll(stickerSelector),
            {
              clearProps: 'all',
              duration: 0.8,
              stagger: { amount: 1, from: 'random' },
              trigger: this
            }
          )
          this.#teardownInertia = usePointerInertia(
            scope.gsap,
            this.querySelectorAll(inertiaElementSelector)
          )
          return () => {
            this.#teardownStickerReveal?.()
            this.#teardownStickerReveal = null
            this.#teardownInertia?.()
            this.#teardownInertia = null
          }
        }
      )
    })

    this.#gsapContext = scope.context
  }
}

if (!customElements.get('footer-stickers')) {
  customElements.define('footer-stickers', FooterStickers)
}
